import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTabItem,
	CardTitle,
} from '../../../components/bootstrap/Card';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';

import Icon from '../../../components/icon/Icon';
import moment from 'moment';
import ClientMontantContext from '../../../contexts/clientMontantContext';

import ValidationPaiement from './validationPaiement';
import HeaderPage from './HeaderPage';
import { MailMenu } from 'gestioneerMenu';
import SubHeader, { SubHeaderLeft, SubHeaderRight, SubheaderSeparator } from 'layout/SubHeader/SubHeader';
import { getPublicDevis } from 'apis/backend/apiPublic';
import { formatCurrency } from 'pages/comptabilite/utils/functions';



const Checkout = () => {
	const { id } = useParams(0);
	const { token } = useParams(0);
	const { model } = useParams(0);
	const [result, setResult] = useState();
	const [clientSecret, setClientSecret] = useState('');
	const { clientMontant, setClientMontant } = useContext(ClientMontantContext);
	const [activeTab, setActiveTab] = useState('paypal');
	const [amount, setAmount] = useState();
	const [stripePromise, setStripePromise] = useState();
	const [paiementPopup, setpaiementPopup] = useState(true);
	const [confirmPaiement, setConfirmPaiement] = useState(false);
	const [devis, setDevis] = useState();
	const [devisLines, setDevisLines] = useState();
	const [openSignature, setOpenSignature] = useState(false);
	const [readDevis, setReadDevis] = useState(false);
	const [spinner, setSpinner] = useState(false);
	const navigate = useNavigate();
	const loadData = useCallback(async () => {
		try {
			const response = await getPublicDevis(id, token);
			const data = response.data;
			if (response?.success && data) {
				setReadDevis(true);
				setDevis(data);
				setAmount(data?.totalTTC)
			} else {
				setReadDevis(false);
			}
		} catch (err) {
			setReadDevis(false);
		} finally {
			setSpinner(true);
		}
	}, [id]);


	useEffect(() => {
		loadData();
	}, [id, token]);
	const [formToken, setFormToken] = useState(null);


	useEffect(() => {
		if (!formToken) return;

		requestAnimationFrame(() => {
			if (window.KR?.setFormToken) {
				window.KR.setFormToken(formToken);
			}
		});

		window.KR?.onSubmit(async ({ KR, event }) => {
			try {
				// event contient la transaction. (structure exacte dépend du mode)
				// Envoie un signal à ton backend (ne pas mettre de secret ici)
				console.log("ssuucccesssss")

				// IMPORTANT: retourne true pour laisser Systempay continuer (redirect/flow)
				return true;
			} catch (e) {
				console.error("client-success error:", e);
				// Si tu retournes false => tu coupes la chaîne (pas de redirect / gestion standard)
				// En général: laisse true, et gère l’erreur côté UI.
				return true;
			}


		});
		window.KR?.onError(({ KR, event }) => {
			console.log("Payment refused:", event);
			return true;
		});
	}, [formToken]);
	return (
		<>
			<PageWrapper title={MailMenu?.paiement?.text} isProtected={false}>
				{!!readDevis && (
					<SubHeader>
						<SubHeaderLeft>
							<img
								src={!!devis?.companyId?.logo ? `/coreService/${devis?.companyId?.logo}` : null}
								alt=''
								className='p-4'
								width='300'
								height='100'
							/>
							<SubheaderSeparator />
						</SubHeaderLeft>
						<SubHeaderRight className='d-block text-end'>
							<div className='fs-4 fw-bold'>{devis?.companyId?.name}</div>
							<div className='text-muted'>{devis?.companyId?.email}</div>
							<div className='text-muted'>{devis?.companyId?.phone}</div>
							<div></div>
						</SubHeaderRight>
					</SubHeader>)}

				<Page>
					{!!spinner && (
						<>
							{readDevis ? (
								<>
									{(paiementPopup && !!amount) ? (
										<ValidationPaiement
											setAmount={setAmount}
											setpaiementPopup={setpaiementPopup}
											amount={amount}
											orderRef={devis?.reference}   // ✅ renamed
											email={devis?.clientId?.emails?.[0]}
											onFormToken={setFormToken}
										/>

									) : (
										<div className='row '>
											<div className='col-lg-6'>
												<Card shadow='sm' className='mb-4'>
													<CardBody>
														<div className='border-bottom text-center mb-4 pb-3'>
															<div className='text-muted mb-2'>
																Montant a payer
															</div>
															<h1 className='display-4 fw-bold text-primary mb-0'>
																{formatCurrency(amount, 'EUR')}
															</h1>

														</div>

														{/* Action Buttons */}

													</CardBody>
												</Card>
											</div>

											<div className='col-lg-6'>
												<Card>


													<CardHeader>
														<CardLabel icon='Payments' iconColor='primary'>
															<CardTitle>
																Complétez votre paiement avec Bred !
															</CardTitle>
														</CardLabel>
													</CardHeader>
													<CardBody>

														{!!formToken ? (<>
															<SystempayHead publicKey="73239078:testpublickey_Zr3fXIKKx0mLY9YNBQEan42ano2QsdrLuyb2W54QWmUJQ" />

															<div key={formToken}
																className="kr-smart-form"
																kr-popin
																kr-form-token={formToken}
															>
																<div className="kr-pan" />
																<div className="kr-expiry" />
																<div className="kr-security-code" />
																<button className="kr-payment-button" />
															</div>
														</>
														) : (
															<div className="text-muted text-center">
																Veuillez choisir un montant pour continuer
															</div>
														)}
													</CardBody>



												</Card>
											</div>
										</div>
									)}
								</>
							) : (
								<div className='d-flex justify-content-center align-items-center'>
									{/* Card with error message */}
									<Card
										className='text-center shadow-sm'
										style={{ width: '100%', maxWidth: '600px' }}>
										<CardBody>
											{/* Icon or message */}
											<Icon
												name='exclamation-triangle'
												size='2x'
												color='warning'
											/>
											<CardTitle className='text-danger mt-3'>
												Désolé, ce lien a expiré
											</CardTitle>
											<span className='text-muted'>
												Le lien que vous avez suivi n'est plus valide. Veuillez
												vérifier si vous avez entré l'URL correcte ou
												contactez-nous pour plus d'informations.
											</span>

											{/* Optional: Action button to redirect */}
										</CardBody>
									</Card>
								</div>
							)}
						</>
					)}
				</Page>
			</PageWrapper>
		</>
	);
};

export default Checkout;



function loadTag(tag) {
	return new Promise((resolve, reject) => {
		tag.onload = () => resolve();
		tag.onerror = reject;
		document.head.appendChild(tag);
	});
}

function SystempayHead({ publicKey }) {
	useEffect(() => {
		let cancelled = false;

		async function run() {
			if (document.querySelector('script[data-krypton="true"]')) return;

			// Krypton script
			const s1 = document.createElement("script");
			s1.src =
				"https://static.systempay.fr/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js";
			s1.async = true;
			s1.setAttribute("data-krypton", "true");
			s1.setAttribute("kr-public-key", publicKey);
			// s1.setAttribute("kr-post-url-success", MailMenu.confirmation.path);
			s1.setAttribute("kr-language", "fr-FR");

			// Neon CSS
			const css = document.createElement("link");
			css.rel = "stylesheet";
			css.href =
				"https://static.systempay.fr/static/js/krypton-client/V4.0/ext/neon-reset.min.css";
			document.head.appendChild(css);

			// Neon JS
			const s2 = document.createElement("script");
			s2.src =
				"https://static.systempay.fr/static/js/krypton-client/V4.0/ext/neon.js";
			s2.async = true;

			try {
				await loadTag(s1);
				if (cancelled) return;
				await loadTag(s2);
			} catch (e) {
				console.error("Systempay load error:", e);
			}
		}

		run();
		return () => {
			cancelled = true;
		};
	}, [publicKey]);

	return null;
}

